import {
    Attr
} from '@vuex-orm/core'

export default class ObjAttr extends Attr {
    
    constructor(
        model, 
        value, 
        extra,
        mutator
    ) {
        super(model, 
            value, 
            mutator)
        this.extra = extra || {}
    }

    toString(name) {
        return name + ' { ' + this.extra + '}' 
    }
}